<template>
  <div class="device-detail-sheet-current-day">
    <div class="box">
      <div class="title">
        <i class="icon icon-tishi"></i>
        {{ dayTips }}
      </div>
      <div class="sheet-info">
        <ul class="box">
          <template v-for="func in deviceInfo.supportFunc.split(',')">
            <template v-if="func === 'manual'">
            <li class="item" :key="func">
              <p class="mode">{{ $t('dms_device_detail_sheet_currentDay.ren_gong_qing_jie') }}</p>
              <ul>
                <li class="param">
                  <h2 :title="$t('dms_device_detail_sheet_currentDay.qing_jie_shi_changhm')">
                    {{ $t('dms_device_detail_sheet_currentDay.qing_jie_shi_changhm') }}
                  </h2>
                  <p>{{ info.manualUsageTime === 0 ? '-' : $formatSecToHm(info.manualUsageTime) }}</p>
                </li>
                <li class="param">
                  <h2 :title="$t('dms_device_detail_sheet_currentDay.qing_jie_mian_jio', [$formatLenUnit()])">
                    {{ $t('dms_device_detail_sheet_currentDay.qing_jie_mian_ji') }} {{$formatLenUnit()}}
                  </h2>
                  <p>{{ info.manualCleanArea === 0 ? '-' : $formatLenLocal($toFixed(info.manualCleanArea)) | formatThousandth}}</p>
                </li>
                <li class="param">
                  <h2 :title="$t('dms_device_detail_sheet_currentDay.qing_jie_ci_shu')">
                  {{ $t('dms_device_detail_sheet_currentDay.qing_jie_ci_shu') }}
                  </h2>
                  <p>{{ info.manualUsageCount }}</p>
                </li>
              </ul>
            </li>
            </template>
            <!-- 智能清洁 -->
            <template v-else-if="func === 'autonomous'">
              <li class="item" :key="func">
                <p class="mode">{{ $t('dms_device_detail_sheet_currentDay.zi_zhu_qing_jie') }}</p>
                <ul>
                  <li class="param">
                    <h2 :title="$t('dms_device_detail_sheet_currentDay.qing_jie_shi_changhm')">
                      {{ $t('dms_device_detail_sheet_currentDay.qing_jie_shi_changhm') }}
                    </h2>
                    <p>{{ info.autonomousUsageTime === 0 ? '-' : $formatSecToHm(info.autonomousUsageTime) }}</p>
                  </li>
                  <li class="param">
                    <h2 :title="$t('dms_device_detail_sheet_currentDay.qing_jie_mian_jio', [$formatLenUnit()])">
                      {{ $t('dms_device_detail_sheet_currentDay.qing_jie_mian_ji') }} {{$formatLenUnit()}}
                    </h2>
                    <p>{{ info.autonomousCleanArea === 0 ? '-' : $formatLenLocal($toFixed(info.autonomousCleanArea)) | formatThousandth}}</p>
                  </li>
                  <li class="param">
                    <h2 :title="$t('dms_device_detail_sheet_currentDay.fu_zhu_ci_shu')">
                      {{ $t('dms_device_detail_sheet_currentDay.fu_zhu_ci_shu') }}
                    </h2>
                    <p>{{ info.assistCount }}</p>
                  </li>
                </ul>
              </li>
            </template>
            <!-- 教学 -->
            <template v-else-if="func === 'training'">
              <li class="item" :key="func">
                <p class="mode">{{ $t('dms_device_detail_sheet_currentDay.jiao_xue') }}</p>
                <ul>
                  <li class="param">
                    <h2 :title="$t('dms_device_detail_sheet_currentDay.jiao_xue_shi_changhm')">
                      {{ $t('dms_device_detail_sheet_currentDay.jiao_xue_shi_changhm') }}
                    </h2>
                    <p>{{ info.trainingUsageTime === 0 ? '-' : $formatSecToHm(info.trainingUsageTime) }}</p>
                  </li>
                  <li class="param">
                    <h2 :title="$t('dms_device_detail_sheet_currentDay.jiao_xue_mian_jio', [$formatLenUnit()])">
                      {{ $t('dms_device_detail_sheet_currentDay.jiao_xue_mian_ji') }}{{$formatLenUnit()}}
                    </h2>
                    <p>{{ info.trainingCleanArea === 0 ? '-' : info.trainingCleanArea }}</p>
                  </li>
                </ul>
              </li>
            </template>
            <!-- 开机 -->
            <template v-else-if="func === 'boot'">
              <li class="item" :key="func">
                <p class="mode">{{ $t('dms_device_detail_sheet_currentDay.kai_ji') }}</p>
                <ul>
                  <li class="param">
                    <h2 :title="$t('dms_device_detail_sheet_currentDay.kai_ji_shi_changhm')">
                      {{$t('dms_device_detail_sheet_currentDay.kai_ji_shi_changhm')}}
                    </h2>
                    <p>{{ info.bootTime === 0 ? '-' : $formatSecToHm(info.bootTime) }}</p>
                  </li>
                  <li class="param">
                    <h2 :title="$t('dms_device_detail_sheet_currentDay.kai_ji_ci_shu')">
                      {{$t('dms_device_detail_sheet_currentDay.kai_ji_ci_shu')}}
                    </h2>
                    <p>{{ info.bootCount }}</p>
                  </li>
                </ul>
              </li>
            </template>
            <!-- 充电 -->
            <template v-else-if="func === 'charging'">
              <li class="item" :key="func">
                <p class="mode">{{ $t('dms_device_detail_sheet_currentDay.chong_dian') }}</p>
                <ul>
                  <li class="param">
                    <h2 :title="$t('dms_device_detail_sheet_currentDay.cdschm')">
                      {{ $t('dms_device_detail_sheet_currentDay.cdschm') }}
                    </h2>
                    <p>{{ info.chargingTime === 0 ? '-' : $formatSecToHm(info.chargingTime) }}</p>
                  </li>
                </ul>
              </li>
            </template>
          </template>
        </ul>
        <!-- <p class="box-bottom" v-if="info.lastDataUploadedTime">{{ $t('page_content_last_cleaning_time }}:{{ info.lastDataUploadedTime }}</p> -->
      </div>
    </div>
    <!-- ice使用详情 -->
    <template v-if="`${deviceInfo.productClass}` === '1' && listFlage">
      <div class="detail-list box box1">
        <div class="search-hd card-search">
          <el-form :inline="true" @submit.native.prevent>
            <el-form-item>
              <el-radio-group v-model="detailType" style="vertical-align: top" class="detail-type">
                <el-radio-button :label="0">{{ $t('dms_device_detail_sheet_currentDay.shu_ju_xiang_qing') }}</el-radio-button>
                <el-radio-button :label="1">{{ $t('dms_device_detail_sheet_currentDay.kjksyxq') }}</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <!-- 配置项 -->
            <el-form-item style="float: right; margin-right: 0" v-show="detailType === 0">
              <custom-column ref="column"></custom-column>
            </el-form-item>
            <el-form-item style="float: right" v-show="detailType === 0">
              <el-button class="table-set" style="vertical-align: top" @click="exportDay">
                <i class="icon icon-daochu"></i>
              </el-button>
            </el-form-item>
            <el-form-item style="float: right" v-show="detailType === 0">
              <switch-button :link="link" ref="switchButton"></switch-button>
            </el-form-item>
          </el-form>
        </div>
        <div>
          <switch-container ref="container" @search="getSheetDayInfo()" @clear="clearFilter()">
            <el-form :inline="true" label-position="top">
              <el-form-item :label="$t('dms_device_detail_sheet_currentDay.jie_shu_shi_jian')">
                <!-- 已修改时区 -->
                <el-time-picker is-range v-model="formSearch.timer" range-separator="——" start-placeholder="" value-format="yyyy-MM-dd HH:mm:ss" end-placeholder=""></el-time-picker>
              </el-form-item>
              <!-- 卡号 -->
              <el-form-item :label="$t('dms_device_detail_sheet_currentDay.ka_hao')">
                <el-input v-model="formSearch.bootCardNum" placeholder="" style="width: 100%"></el-input>
              </el-form-item>
              <el-form-item :label="$t('dms_device_detail_sheet_currentDay.mo_shi')">
                <custom-select v-model="formSearch.workClass" code="iot_tsl_use_type2" :placeholder="$t('Common.com_please_select')" width="100%"></custom-select>
              </el-form-item>
              <!-- 使用人 -->
              <el-form-item :label="$t('dms_device_detail_sheet_currentDay.chi_ka_ren')">
                <el-input v-model="formSearch.bootCardOwner" placeholder="" style="width: 100%"></el-input>
              </el-form-item>
              <!--  -->
            </el-form>
          </switch-container>
          <template v-if="detailType === 0">
            <div class="table-bd">
              <custom-table
                v-if="isInch"
                tableCode="device_sheet_day_zone_ice_ft"
                :data="dayList"
                :index="true"
                @filter="filterChange"
                @sort="sortChange"
                @column="setColumn"
                :filterArr="`${deviceInfo.productClass}` === '1' ? ['map'] : []"
                :slots="['map','cleanedArea','runLength']"
              >
                <template v-slot:cleanedArea="scope">
                  <span>{{$formatLenLocal(scope.row.cleanedArea)| formatThousandth}}</span>
                </template>
                <template v-slot:runLength="scope">
                  <span>{{$formatLenLocal(scope.row.runLength,true)}}</span>
                </template>
                <template v-slot:map="scope">
                  <span
                    v-if="!!scope.row.routeId && (`${scope.row.workClass}` === '5' || `${scope.row.workClass}` === '4')"
                    style="cursor: pointer; color: #0d9ae0"
                    @click="mapIdDetails(scope.row.routeId, scope.row.workClass)"
                  >
                    {{ $t('Common.com_detail') }}
                  </span>
                </template>
              </custom-table>
              <custom-table
                v-else
                tableCode="device_sheet_day_zone_ice"
                :data="dayList"
                :index="true"
                @filter="filterChange"
                @sort="sortChange"
                @column="setColumn"
                :filterArr="`${deviceInfo.productClass}` === '1' ? ['map'] : []"
                :slots="['map']"
              >
                <template v-slot:map="scope">
                  <span
                    v-if="!!scope.row.routeId && (`${scope.row.workClass}` === '5' || `${scope.row.workClass}` === '4')"
                    style="cursor: pointer; color: #0d9ae0"
                    @click="mapIdDetails(scope.row.routeId, scope.row.workClass)"
                  >
                    {{ $t('Common.com_detail') }}
                  </span>
                </template>
              </custom-table>
            </div>
          </template>
          <template v-if="detailType === 1">
            <div class="card" v-if="iceCardList.length">
              <ul>
                <li class="card-line" v-for="(item, index) in iceCardList" :key="index">
                  <div class="icon">
                    <template>
                      <img v-if="`${item.bootCardColor}` === '2'" src="~@/images/layout/card-2.png" />
                      <img v-else-if="`${item.bootCardColor}` === '3'" src="~@/images/layout/card-3.png" />
                      <img v-else-if="`${item.bootCardColor}` === '4'" src="~@/images/layout/card-4.png" />
                      <img v-else src="~@/images/layout/card-1.png" />
                    </template>
                  </div>
                  <div class="info" style="min-width: 90px">
                    <p>{{ dms_boot_card_color[item.bootCardColor] }}</p>
                    <span class="value" v-if="item.bootCardNum">ID: {{ item.bootCardNum }}</span>
                  </div>
                  <div class="inner">
                    <div class="param">
                      <div class="name">
                        <p>{{ $t('dms_device_detail_sheet_currentDay.shi_yong_ren') }}</p>
                        <span class="value">{{ item.bootCardOwner || '-' }}</span>
                      </div>
                      <div class="name" style="width: 100px">
                        <p>{{ $t('dms_device_detail_sheet_currentDay.mo_shi') }}</p>
                        <span class="value">{{ iot_tsl_use_type2[item.workClass] || '-' }}</span>
                      </div>

                      <!-- 人工-->
                      <template v-if="`${item.workClass}` === '2'">
                        <div class="name" style="width: 120px">
                          <p>{{ $t('dms_device_detail_sheet_currentDay.qing_jie_shi_changhm') }}</p>
                          <span class="value">{{ item.manualUsageTime === 0 ? '-' : $formatSecToHm(item.manualUsageTime) }}</span>
                        </div>
                        <div class="name" style="width: 120px">
                          <p>{{ $t('dms_device_detail_sheet_currentDay.qing_jie_mian_ji') }} {{$formatLenUnit()}}</p>
                          <span class="value">{{ item.manualCleanArea === 0 ? '-' : $formatLenLocal($toFixed(item.manualCleanArea))| formatThousandth || '-' }}</span>
                        </div>
                        <div class="name" style="width: 120px">
                          <p>{{ $t('dms_device_detail_sheet_currentDay.qing_jie_ci_shu') }}</p>
                          <span class="value">{{ item.manualUsageCount}}</span>
                        </div>
                      </template>
                      <!-- 智能清洁-->
                      <template v-if="`${item.workClass}` === '5'">
                        <div class="name" style="width: 120px">
                          <p>{{ $t('dms_device_detail_sheet_currentDay.qing_jie_shi_changhm') }}</p>
                          <span class="value">{{ item.autonomousUsageTime === 0 ? '-' : $formatSecToHm(item.autonomousUsageTime) }}</span>
                        </div>
                        <div class="name" style="width: 120px">
                          <p>{{ $t('dms_device_detail_sheet_currentDay.qing_jie_mian_ji') }} {{$formatLenUnit()}}</p>
                          <span class="value">{{ item.autonomousCleanArea === 0 ? '-' : $formatLenLocal($toFixed(item.autonomousCleanArea))| formatThousandth || '-' }}</span>
                        </div>
                        <!-- <div class="name" >
                        <p>{{ $t('page_content_assists }}</p>
                        <span class="value">{{ item.assistCount }}</span>
                      </div> -->
                      </template>
                      <!-- 教学-->
                      <template v-if="`${item.workClass}` === '4'">
                        <div class="name" style="width: 120px">
                          <p>{{ $t('dms_device_detail_sheet_currentDay.jiao_xue_shi_changhm') }}</p>
                          <span class="value">{{ item.trainingUsageTime === 0 ? '-' : $formatSecToHm(item.trainingUsageTime) }}</span>
                        </div>
                        <div class="name" style="width: 120px">
                          <p>{{ $t('dms_device_detail_sheet_currentDay.jiao_xue_mian_ji') }}{{$formatLenUnit()}}</p>
                          <span class="value">{{ item.trainingCleanArea === 0 ? '-' : item.trainingCleanArea || '-' }}</span>
                        </div>
                      </template>
                      <!-- 开机-->
                      <template  v-if="`${item.workClass}` === '8'">
                        <div class="name" style="width: 120px">
                          <p>{{ $t('dms_device_detail_sheet_currentDay.kai_ji_shi_changhm') }}</p>
                          <span class="value">{{ item.bootTime === 0 ? '-' : $formatSecToHm(item.bootTime) }}</span>
                        </div>
                        <div class="name" style="width: 120px">
                          <p>{{ $t('dms_device_detail_sheet_currentDay.kai_ji_ci_shu') }}</p>
                          <span class="value">{{ item.bootCount}}</span>
                        </div>
                      </template>
                      <!-- 充电-->
                      <template v-if="`${item.workClass}` === '1'">
                        <div class="name" style="width: 120px">
                          <p>{{ $t('dms_device_detail_sheet_currentDay.cdschm') }}</p>
                          <span class="value">{{ item.chargingTime === 0 ? '-' : $formatSecToHm(item.chargingTime) }}</span>
                        </div>
                      </template>
                    </div>
                  </div>
                  <div class="more" @click="onCardDetails(item)">
                    {{ $t('dms_device_detail_sheet_currentDay.cha_kan_xiang_qing') }}
                    <i class="icon icon-you"></i>
                  </div>
                </li>
              </ul>
            </div>
          </template>
        </div>
      </div>
    </template>
    <!-- sbr -->
    <template v-if="`${deviceInfo.productClass}` === '2' && listFlage">
      <div class="detail-list box box2">
        <!-- 数据详情 -->
        <div class="path">
          <div class="search-hd">
            <el-form :inline="true" @submit.native.prevent>
              <!-- <el-form-item>
                <p class="titel">
                  {{ $t('page_content_boot_card_use_details1 }}
                </p>
              </el-form-item> -->
              <el-form-item style="float: right; margin-right: 0">
                <custom-column ref="column"></custom-column>
              </el-form-item>
              <!-- 导出 -->
              <el-form-item style="float: right">
                <el-button class="table-set" style="vertical-align: top" @click="exportDay">
                  <i class="icon icon-daochu"></i>
                </el-button>
              </el-form-item>
              <el-form-item style="float: right">
                <switch-button :link="link1"></switch-button>
              </el-form-item>
            </el-form>
          </div>
          <switch-container ref="container1" @search="getSheetDayInfo()" @clear="clearFilter()">
            <el-form :inline="true" label-position="top">
              <el-form-item :label="$t('dms_device_detail_sheet_currentDay.jie_shu_shi_jian')">
                <!-- 已修改时区 -->
                <el-time-picker is-range v-model="formSearch.timer" range-separator="——" start-placeholder="" value-format="yyyy-MM-dd HH:mm:ss" end-placeholder=""></el-time-picker>
              </el-form-item>
              <!-- 站点 -->
              <el-form-item :label="$t('dms_device_detail_sheet_currentDay.zhan_dian')">
                <custom-select
                  url="DeviceReportSiteSiteList"
                  :props="{ label: 'siteName', value: 'siteCode' }"
                  :auto="false"
                  :listener="`${formSearch.bodyNum}${formSearch.startTime}${formSearch.endTime}`"
                  :placeholder="$t('Common.com_please_select')"
                  :params="{ ...formSearch }"
                  v-model="formSearch.siteCode"
                  :noBoder="true"
                  width="100%"
                ></custom-select>
              </el-form-item>
              <!-- 定位码 -->
              <el-form-item :label="$t('dms_device_detail_sheet_currentDay.ding_wei_ma')">
                <el-input v-model="formSearch.hlcCode" placeholder="" style="width: 100%"></el-input>
              </el-form-item>
              <el-form-item :label="$t('dms_device_detail_sheet_currentDay.lu_xian_cao')">
                <el-input v-model="formSearch.slotCode" placeholder="" style="width: 100%"></el-input>
              </el-form-item>
              <el-form-item :label="$t('dms_device_detail_sheet_currentDay.mo_shi')">
                <custom-select v-model="formSearch.workClass" code="iot_tsl_use_type2" :placeholder="$t('Common.com_please_select')" width="100%"></custom-select>
              </el-form-item>
              <!-- 地图名称 -->
              <el-form-item :label="$t('dms_device_detail_sheet_currentDay.di_tu_ming_cheng')">
                <el-input v-model="formSearch.mapName" placeholder="" style="width: 100%"></el-input>
              </el-form-item>
            </el-form>
          </switch-container>
          <div class="table-bd">
            <custom-table
              v-if="isInch"
              tableCode="device_sheet_day_zone_ft"
              :data="dayList"
              :index="true"
              @filter="filterChange"
              @sort="sortChange"
              @column="setColumn"
              :slots="['runRoute', 'workClass','cleanedArea','runLength']"
            >
              <template v-slot:cleanedArea="scope">
                <span>{{$formatLenLocal(scope.row.cleanedArea)| formatThousandth}}</span>
              </template>
              <template v-slot:runLength="scope">
                <span>{{$formatLenLocal(scope.row.runLength,true)}}</span>
              </template>
              <template v-slot:workClass="scope">
                {{ iot_tsl_use_type2[scope.row.workClass] }}
              </template>
              <template v-slot:runRoute="scope">
                <span
                  v-if="!!scope.row.routeId && (`${scope.row.workClass}` === '5' || `${scope.row.workClass}` === '4')"
                  style="cursor: pointer; color: #0d9ae0"
                  @click="mapIdDetails(scope.row.routeId, scope.row.workClass)"
                >
                  {{ $t('Common.com_detail') }}
                </span>
              </template>
            </custom-table>
            <custom-table
              v-else
              tableCode="device_sheet_day_zone"
              :data="dayList"
              :index="true"
              @filter="filterChange"
              @sort="sortChange"
              @column="setColumn"
              :slots="['runRoute', 'workClass']"
            >

              <template v-slot:workClass="scope">
                {{ iot_tsl_use_type2[scope.row.workClass] }}
              </template>
              <template v-slot:runRoute="scope">
                <span
                  v-if="!!scope.row.routeId && (`${scope.row.workClass}` === '5' || `${scope.row.workClass}` === '4')"
                  style="cursor: pointer; color: #0d9ae0"
                  @click="mapIdDetails(scope.row.routeId, scope.row.workClass)"
                >
                  {{ $t('Common.com_detail') }}
                </span>
              </template>
            </custom-table>
          </div>
        </div>
        <!-- 查看地图图片 -->
        <el-image-viewer v-if="dialogVisibleImage" class="img"  :url-list="[dialogImageUrl]"  :on-close="()=>dialogVisibleImage=false" ></el-image-viewer>
      </div>
    </template>
    <!-- 查看开机卡 -->
    <deviceBootCardDetailDialog v-if="dialogVisible" :model="dialogModel" :data="dialogData" @close="dialogVisible = false"></deviceBootCardDetailDialog>
  </div>
</template>

<script>
import moment from 'moment';
import apis from '@/utils/apis';
import deviceBootCardDetailDialog from './device_bootCardDetail_dialog.vue';

export default {
  props: {
    deviceInfo: [Object, Array],
    value: {
      type: String,
      default() {
        return '';
      },
    },
    isCharging: {
      type: Boolean,
      default: false,
    },
    isManual: {
      type: Boolean,
      default: false,
    },
    isAutonomous: {
      type: Boolean,
      default: false,
    },
    isTraining: {
      type: Boolean,
      default: false,
    },
    isBoot: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    dayTips() {
      return this.$t('dms_device_detail_sheet_currentDay.bbyoodojqscdsjsc', [this.area,this.tipsDayStartTime,this.tipsDayEndTime]);
    },
  },
  components: {
    deviceBootCardDetailDialog,
  },
  data() {
    return {
      container: null,
      container1: null,
      info: {
        // ICE
        chargingTime: '', // 充电时长
        manualUsageTime: '', // 手工清洁时间
        manualCleanArea: '', // 手工清洁面积
        manualUsageCount: '', // 手工清洁次数
        lastDataUploadedTime: '', // 最后清洁时间
        // SBR
        // 手工清洁时长 h:m ,
        // 手工清洁面积 m²,
        autonomousUsageTime: '', // 智能清洁时长 h:m',
        autonomousCleanArea: '', // 智能清洁面积 m²',
        assistCount: '', // 辅助次数,
        trainingUsageTime: '', // 教学时长 h:m,
        trainingCleanArea: '', // 教学面积 m²,
        totalUsageCount: '', // 清洁次数,
        bootTime: '', // 开机时长 h:m,
        bootCount: '', // 开机次数,
      },
      // startTime: this.$momentWorld(moment().format('YYYY-MM-DD 00:00:00')),
      // endTime: this.$momentWorld(moment().format('YYYY-MM-DD 23:59:59')),
      startTime: '',
      endTime: '',
      // 提示开始区间
      tipsDayStartTime: '',
      tipsDayEndTime: '',
      area: '',

      formSearch: {
        // bodyNum: '0002190500067',
        // startTime : '2020-06-12 00:00:00',
        // endTime : '2020-06-12 23:59:59'
        bodyNum: this.deviceInfo.bodyNum,
        // startTime: this.$momentWorld(moment().format('YYYY-MM-DD 00:00:00')),
        // endTime: this.$momentWorld(moment().format('YYYY-MM-DD 23:59:59')),
        startTime: '',
        endTime: '',
        // 筛选
        timer: '',
        searchStartTime: '', // 结束时间
        searchEndTime: '', // 结束时间
        bootCardNum: '', // 卡号
        workClass: '',
        bootCardOwner: '',

        siteCode: '', // 站点
        hlcCode: '', // 定位码
        slotCode: '', // 路径
        mapName: '', // 路径
      },
      dayList: [],
      listFlage: false,
      // totalRows: null,

      scheduleList: [],
      detailType: 0,

      // 卡机卡弹窗
      dialogVisible: false,
      dialogModel: {},
      dialogData: {},

      dialogVisibleImage: false,
      dialogImageUrl: '',

      iceCardList: [],
      // 字典
      dms_boot_card_color: {},
      iot_tsl_use_type2: {},
      link1: null,
      link: null,
    };
  },
  watch: {
    dayList: {
      immediate: true,
      handler(list) {
        // sbr
        if (list.length > 0) {
          if (`${this.deviceInfo.productClass}` === '1') {
            setTimeout(() => {
              this.link = this.$refs.container;
            }, 500);
          } else {
            setTimeout(() => {
              this.link1 = this.$refs.container1;
            }, 500);
          }
        }
      },
    },
    detailType(val) {
      if (val === 1) {
        this.$refs.switchButton.triggerClose();
      }
    },
  },
  mounted() {
    this.getDailyTime();
    // this.getSheetInfo();
    this.monitoring(); // 注册监听刷新
    // this.getSheetDayInfo();
    // this.getSheetIceDayInfo();
    // this.getSheetInfo();
    this.getDictionary('dms_boot_card_color,iot_tsl_use_type2', (data) => {
      this.dms_boot_card_color = this.$transformDicValue(data.dms_boot_card_color);
      this.iot_tsl_use_type2 = this.$transformDicValue(data.iot_tsl_use_type2);
    });
  },

  methods: {
    // 获取今日报表时间区间
    getDailyTime: function () {
      this.$getJSON(apis.DeviceReportDailyTime, {
        bodyNum: this.deviceInfo.bodyNum,
      }).then((res) => {
        this.tipsDayStartTime = res.data.startTime;
        this.tipsDayEndTime = res.data.endTime;
        this.area = res.data.hqTimeName;
        //
        // this.formSearch.startTime = this.$momentWorld(res.data.startTime);
        // this.formSearch.endTime = this.$momentWorld(res.data.endTime);
        this.formSearch.startTime = res.data.reportStartTime;
        this.formSearch.endTime = res.data.reportEndTime;
        this.getSheetDayInfo();
        if (`${this.deviceInfo.productClass}` === '1') {
          this.getSheetIceDayInfo();
        }
        this.getSheetInfo();
      });
    },
    // 获取今日详情
    getSheetInfo: function () {
      this.$getJSON(apis.DeviceReportDaily, {
        bodyNum: this.deviceInfo.bodyNum,
        // bodyNum: '0002190500067',
        reportDate: this.$momentElLocal(new Date(), 'YYYY-MM-DD')
      }).then((res) => {
        // this.$setFormatData(this.info, res.data);
        if (res.data && Object.keys(res.data).length !== 0) {
          this.$setFormatData(this.info, res.data);
        } else {
          this.info.chargingTime = '';
          this.info.manualUsageTime = '';
          this.info.manualRunLength = '';
          this.info.manualCleanArea = '';
          this.info.manualUsageCount = '';
          this.info.autonomousUsageTime = '';
          this.info.autonomousRunLength = '';
          this.info.autonomousCleanArea = '';
          this.info.trainingUsageTime = '';
          this.info.trainingRunLength = '';
          this.info.trainingCleanArea = '';
          this.info.assistCount = '';
          this.info.totalUsageCount = '';
          this.info.bootTime = '';
          this.info.bootCount = '';
        }

        const lastDataUploadedTime = res.data && res.data.lastDataUploadedTime || '';
        this.$emit('input', lastDataUploadedTime);
        // }
      });
    },
    monitoring() {
      // 监听事件
      this.$on('onRefresh', () => {
        this.getDailyTime();
        // this.getSheetInfo();
      });
    },

    // 获取今日详情
    // getSheetInfo: function () {
    //   this.$getJSON(apis.DeviceReportDaily, this.formSearch).then((res) => {
    //     // this.info = res.data;
    //     if (res.data && Object.keys(res.data).length !== 0) {
    //       this.info = res.data;
    //     } else {
    //       this.info.chargingTime = '';
    //       this.info.usageTimeFormat = '';
    //       this.info.cleanedArea = '';
    //     }
    //   });
    // },
    // 获取今日详情
    getSheetDayInfo: function () {
      let tipsDayStartTime;
      let tipsDayEndTime;
      const timer = this.formSearch.timer;
      // const startTime = this.formSearch.startTime;
      const YYYYMMDD = moment(this.formSearch.endTime).format('YYYY-MM-DD');
      if (timer && timer[0]) {
        const startTimeStr = this.$momentWorld(`${YYYYMMDD} ${timer[0].split(' ')[1]}`);
        const endTimeStr = this.$momentWorld(`${YYYYMMDD} ${timer[1].split(' ')[1]}`);
        tipsDayStartTime = startTimeStr;
        tipsDayEndTime = endTimeStr;
      }
      this.formSearch.workClass = `${this.formSearch.workClass}`;
      const reqData = {
        ...this.formSearch,
        startTime: tipsDayStartTime || this.formSearch.startTime,
        endTime: tipsDayEndTime || this.formSearch.endTime,
        isTimeSearch: tipsDayEndTime ? 1 : 0,
        reportDate: this.$momentElLocal(new Date(), 'YYYY-MM-DD')
      };

      this.$getJSON(apis.DeviceReportDailyWorkRunList, reqData).then((res) => {
        if (`${this.deviceInfo.productClass}` === '1') {
          const data = res.data || [];
          // 如果是充电模式
          data.forEach((i) => {
            if (`${i.workClass}` === '1') {
              i.bootCardNum = '-';
              i.bootCardColor = '-';
              i.bootCardOwner = '-';
              i.cleanedArea = '-';
              i.runLength = '-';
            }
          });
          this.nullValueToCrossbar(data, ['assistCount']);
          this.dayList = data;
        } else {
          const data = res.data || [];
          // 如果是充电模式
          data.forEach((i) => {
            if (`${i.workClass}` === '1') {
              i.siteName = '-';
              i.hlcCode = '-';
              i.slotCode = '-';
              i.cleanedArea = '-';
              i.usageTimeFormat = '-';
              i.runLength = '-';
              i.assistCount = '-';
            }
          });
          this.nullValueToCrossbar(data, ['assistCount']);
          this.dayList = data;
        }
        if (this.dayList.length > 0) {
          this.listFlage = true;
        }
      });
    },
    // ice报表开机卡
    getSheetIceDayInfo: function () {
      this.$getJSON(apis.DeviceReportDailyBootCardList, { ...this.formSearch, reportDate: this.$momentElLocal(new Date(), 'YYYY-MM-DD') }).then((res) => {
        this.iceCardList = res.data;
      });
    },

    // 查看地图  ICER协议才有
    mapIdDetails(routeId, workClass) {
      // w是自主
      // t是教学
      let type = '';
      if (`${workClass}` === '5') {
        type = 'w';
      } else if (`${workClass}` === '4') {
        type = 't';
      }
      if (!routeId || !type) {
        return;
      }
      this.$getJSON(`${apis.OssAttach}/${routeId}/${type}`).then((res) => {
        const list = res.data || [];
        const url = this.getAttachUrl(list[0]);
        this.dialogImageUrl = url;
        this.dialogVisibleImage = true;
      });
    },
    // 查看地图
    mapDetails(url) {
      this.dialogVisibleImage = true;
      this.dialogImageUrl = url;
    },
    onPageChange() {
      this.getSheetDayInfo();
    },
    // 数据导出
    exportDay: function () {
      this.$exportFlie(apis.DeviceReportDailyWorkRunExport, { ...this.formSearch, reportDate: this.$momentElLocal(new Date(), 'YYYY-MM-DD') }).then(() => {});
    },
    onCardDetails(row) {
      this.dialogVisible = true;
      this.dialogModel.type = 'see';
      this.dialogModel.title = this.$t('dms_device_detail_sheet_currentDay.kjksyxq');

      this.dialogModel.bodyNum = this.deviceInfo.bodyNum;
      this.dialogModel.startTime = this.formSearch.startTime;
      this.dialogModel.endTime = this.formSearch.endTime;
      // 有可能会出现没有卡号
      this.dialogModel.bootCardNum = row.bootCardNum || '';
      this.dialogModel.data = row;
    },
    clearFilter: function () {
      this.formSearch.bootCardNum = ''; // 路径
      this.formSearch.timer = ''; // 发布时间
      this.formSearch.workClass = ''; // 模式
      this.formSearch.bootCardOwner = ''; // 操作人

      this.formSearch.mapName = ''; // 站点
      this.formSearch.siteCode = ''; // 站点
      this.formSearch.hlcCode = ''; // 定位码
      this.formSearch.slotCode = ''; // 路径
      this.getSheetDayInfo();
    },
  },
};
</script>

<style lang="scss">
.device-detail-sheet-current-day {
  margin-top: 24px;
  .title {
    padding-left: 10px;
    background: rgba(53, 184, 224, 0.15);
    border-radius: 2px;
    font-size: 12px;
    line-height: 32px;
    color: rgba(108, 117, 125, 1);
    .icon {
      color: RGBA(13, 154, 224, 1);
      margin-right: 10px;
    }
  }
  .sheet-info {
    // margin-top: 16px;
    .box {
      padding: 24px 16px;
      display: flex;
      li.item {
        border-right: 1px solid #e9ebec;
        margin-left: 32px;
        &:first-child {
          margin: 0;
        }
        .mode {
          height: 28px;
          font-size: 15px;
          font-weight: bold;
          color: #0d9ae0;
          line-height: 28px;
          margin-bottom: 12px;
        }
        ul {
          display: flex;
          .param {
            padding-right: 32px;
            h2 {
              height: 17px;
              font-size: 12px;
              color: rgba(152, 166, 173, 1);
              line-height: 17px;
              margin-bottom: 5px;
              white-space: normal;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            p {
              height: 26px;
              font-size: 22px;
              font-weight: bold;
              color: rgba(57, 70, 104, 1);
              line-height: 26px;
            }
          }
        }

        &:last-of-type {
          border: none;
        }
      }
    }
    .time {
      color: #0d9ae0;
    }
    .box-bottom {
      margin-top: 16px;
      text-align: right;
      height: 17px;
      font-size: 12px;
      color: #6c757d;
      line-height: 17px;
    }
  }
  .detail-type {
    // padding-top: 20px;
  }
  .detail-list {
    margin-top: 16px;
    // padding-top: 16px !important;
    .card-search {
      padding-top: 0 !important ;
      padding-bottom: 24px;
      .titel {
        height: 28px;
        font-size: 14px;
        font-weight: bold;
        color: rgba(73, 80, 87, 1);
        line-height: 28px;
        // margin-bottom: 20px;
      }
    }
    .card {
      border-radius: 2px;
      background-color: #fff;
      // margin-top: 16px;
      // padding: 20px 24px;
      // padding: 16px 24px;
      .titel {
        height: 28px;
        font-size: 14px;
        font-weight: bold;
        color: rgba(73, 80, 87, 1);
        line-height: 28px;
        // margin-bottom: 20px;
      }
      ul {
        li {
          height: 70px;
          background: #ffffff;
          padding: 13px 17px 13px 16px;
          display: flex;
          align-items: center;
          // justify-content: space-between;
          .icon {
            width: 44px;
            height: 44px;
            margin-right: 24px;
            img {
              display: inline-block;
              width: 100%;
            }
          }
          .info {
            margin-right: 44px;
            p {
              height: 17px;
              font-size: 12px;
              color: rgba(73, 80, 87, 1);
              line-height: 17px;
            }
            span {
              height: 25px;
              font-size: 13px;

              font-weight: bold;
              color: rgba(73, 80, 87, 1);
              line-height: 25px;
            }
          }
          .inner {
            flex: 1;

            .param {
              display: flex;
              overflow-x: auto;
              .name {
                padding: 0 24px 0 20px;
                border-right: 1px solid #e9ebec;
                flex-shrink: 0;
                p {
                  height: 17px;
                  font-size: 12px;
                  color: rgba(152, 166, 173, 1);
                  line-height: 17px;
                }
                span {
                  height: 25px;
                  font-size: 13px;

                  font-weight: bold;
                  color: rgba(73, 80, 87, 1);
                  line-height: 25px;
                }
                &:last-of-type {
                  border: none !important;
                }
              }
            }
          }
          .card-title {
            height: 21px;
            font-size: 12px;

            font-weight: bold;
            color: rgba(73, 80, 87, 1);
            line-height: 21px;
            .user {
              height: 21px;
              font-size: 12px;
              color: rgba(57, 70, 104, 1);
              line-height: 21px;
            }
            .right {
              float: right;
              height: 17px;
              font-size: 12px;
              color: rgba(13, 154, 224, 1);
              line-height: 17px;
            }
          }
          .card-tips {
            height: 17px;
            font-size: 12px;
            color: rgba(108, 117, 125, 1);
            line-height: 17px;
            .right {
              float: right;
              height: 17px;
              font-size: 12px;
              color: rgba(108, 117, 125, 1);
              line-height: 17px;
            }
          }
          &:hover {
            background: #f9f9fd;
          }
          .more {
            color: #0d9ae0;
            font-size: 12px;
            color: rgba(13, 154, 224, 1);
            line-height: 22px;
            margin-left: auto;
            cursor: pointer;
            i {
              color: #0d9ae0;
              font-size: 12px;
            }
          }
          &:nth-child(odd) {
            background-color: #f9f9fd;
          }
        }
      }
    }
  }
  .path {
    // margin-top: 16px;
    background-color: #fff;
    .search-hd {
      padding-top: 0;
      padding-bottom: 24px;
      overflow: hidden;
    }
    .head {
      margin-bottom: 24px;
      display: flex;
      justify-content: space-between;
      p {
        height: 28px;
        font-size: 14px;
        font-weight: bold;
        color: rgba(73, 80, 87, 1);
        line-height: 28px;
      }
    }
  }
}
</style>
